export const getAudioContextForAudioMixer = () => {
  (window as any).audioContextMixer = (window as any).audioContextMixer ?? new AudioContext();
  return (window as any).audioContextMixer as AudioContext;
};

export const getAudioContextForVolumeAnalyzer = () => {
  (window as any).audioContextAnalyzer = (window as any).audioContextAnalyzer ?? new AudioContext();
  return (window as any).audioContextAnalyzer as AudioContext;
}
